import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../App";

export default function SearchPage() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [view, setView] = useState("all");
  const [leads, setLeads] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    const load = async () => {
      try {
        const [l, a, t] = await Promise.all([
          api.get("/leads").catch(() => ({ data: [] })),
          api.get("/accounts").catch(() => ({ data: [] })),
          api.get("/team-members").catch(() => ({ data: [] })),
        ]);
        setLeads(l.data || []);
        setAccounts(a.data || []);
        setTeam(Array.isArray(t.data) ? t.data : t.data?.users || []);
      } catch {}
      setLoading(false);
    };
    load();
  }, []);

  const filtered = (items, fields) => {
    if (!query.trim()) return items;
    const q = query.toLowerCase();
    return items.filter(i => fields.some(f => (i[f] || "").toLowerCase().includes(q)));
  };

  const chips = [
    { key: "all", label: "All" },
    { key: "leads", label: "Leads" },
    { key: "clients", label: "Clients" },
    { key: "people", label: "People" },
  ];

  return (
    <div>
      {/* IG Search bar */}
      <div style={{ margin: '10px 16px', position: 'relative' }}>
        <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', fontSize: 14, color: '#8E8E8E' }}>🔍</span>
        <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Search with ARIA"
          style={{ width: '100%', padding: '10px 14px 10px 38px', borderRadius: 10, border: 'none', background: '#EFEFEF', fontSize: 14, color: '#262626', outline: 'none' }}
          autoFocus />
      </div>

      {/* IG Chips */}
      <div className="ig-scroll" style={{ display: 'flex', flexWrap: 'nowrap', gap: 6, padding: '4px 16px 10px', overflowX: 'auto', scrollbarWidth: 'none' }}>
        {chips.map(c => {
          const isActive = view === c.key;
          return (
            <button key={c.key} onClick={() => setView(c.key)}
              style={{ padding: '7px 16px', borderRadius: 20, fontSize: 13, fontWeight: 500, background: isActive ? '#262626' : '#EFEFEF', color: isActive ? '#FFF' : '#262626', border: 'none', cursor: 'pointer', flexShrink: 0 }}>
              {c.label}
            </button>
          );
        })}
      </div>

      {/* Leads grid — IG Explore style */}
      {view === "leads" && (
        <div className="ig-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 2, padding: '2px 16px' }}>
          {filtered(leads, ["company_name", "industry"]).slice(0, 30).map(l => {
            const domain = (l.website || '').replace(/https?:\/\//, '').replace(/\/.*/, '');
            return (
              <div key={l.lead_id} onClick={() => navigate(`/bizdev/leads/${l.lead_id}`)}
                style={{ aspectRatio: '1', background: '#EFEFEF', borderRadius: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                {domain && <img src={`https://www.google.com/s2/favicons?domain=${domain}&sz=128`} alt=""
                  style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'contain', marginBottom: 4 }}
                  onError={(e) => e.target.style.display = 'none'} />}
                <div style={{ fontSize: 10, fontWeight: 600, color: '#262626' }}>{l.company_name}</div>
                {l.ai_score && <div style={{ fontSize: 9, color: '#8E8E8E' }}>★{l.ai_score}</div>}
              </div>
            );
          })}
        </div>
      )}

      {/* Clients list */}
      {view === "clients" && (
        <div style={{ paddingTop: 4 }}>
          {filtered(accounts, ["company_name", "industry"]).map(a => (
            <div key={a.lead_id} onClick={() => navigate(`/bizdev/accounts/${a.lead_id}`)}
              style={{ background: '#FFF', borderRadius: 12, margin: '0 16px 8px', boxShadow: '0 1px 3px rgba(0,0,0,.08)', overflow: 'hidden', cursor: 'pointer' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px' }}>
                <img src={`https://www.google.com/s2/favicons?domain=${(a.website || '').replace(/https?:\/\//, '').replace(/\/.*/, '')}&sz=128`} alt=""
                  style={{ width: 36, height: 36, borderRadius: 9, objectFit: 'contain', background: '#EFEFEF' }}
                  onError={(e) => e.target.style.display = 'none'} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#262626' }}>{a.company_name}</div>
                  <div style={{ fontSize: 11, color: '#8E8E8E' }}>
                    {a.is_retainer && <span style={{ color: '#059669' }}>● Retainer · </span>}
                    {a.industry || ''}
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', borderTop: '1px solid #EFEFEF' }}>
                {[
                  { v: a.monthly_retainer_value ? `₹${(a.monthly_retainer_value * 12 / 100).toFixed(1)}Cr` : '—', l: 'Revenue' },
                  { v: '—', l: 'Briefs' },
                  { v: '—', l: 'SOW' },
                ].map((s, j) => (
                  <div key={j} style={{ flex: 1, textAlign: 'center', padding: '8px 4px', borderRight: j < 2 ? '1px solid #EFEFEF' : 'none' }}>
                    <div style={{ fontFamily: "'Orbitron', sans-serif", fontSize: 12, fontWeight: 700, color: '#262626' }}>{s.v}</div>
                    <div style={{ fontSize: 7, color: '#8E8E8E', letterSpacing: '.05em', textTransform: 'uppercase', marginTop: 1 }}>{s.l}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* People list */}
      {view === "people" && (
        <div style={{ padding: '0 16px' }}>
          {(filtered(team, ["name", "full_name", "role"]) || []).map((u, i) => {
            const name = u.name || u.full_name || '';
            const hue = name.split('').reduce((a, c) => a + c.charCodeAt(0), 0) % 360;
            return (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderBottom: '1px solid #EFEFEF', cursor: 'pointer' }}>
                {u.profile_picture ? (
                  <img src={u.profile_picture} alt="" style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover' }} />
                ) : (
                  <div style={{ width: 36, height: 36, borderRadius: '50%', background: `hsl(${hue}, 50%, 40%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: '#fff' }}>
                    {name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()}
                  </div>
                )}
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#262626' }}>{name}</div>
                  <div style={{ fontSize: 10, color: '#8E8E8E' }}>{u.role || u.department || ''}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* All view — Quick access + search results */}
      {view === "all" && !query && (
        <div style={{ padding: '0 16px' }}>
          {/* Quick access links */}
          {[
            { label: 'Leads', sub: `${leads.length} in pipeline`, icon: '◈', onClick: () => setView('leads') },
            { label: 'Clients', sub: `${accounts.length} active`, icon: '▦', onClick: () => setView('clients') },
            { label: 'People', sub: `${team.length} team members`, icon: '👥', onClick: () => setView('people') },
          ].map((item, i) => (
            <div key={i} onClick={item.onClick} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 0', borderBottom: '1px solid #EFEFEF', cursor: 'pointer' }}>
              <div style={{ width: 36, height: 36, borderRadius: 9, background: '#EFEFEF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>{item.icon}</div>
              <div><div style={{ fontSize: 13, fontWeight: 600, color: '#262626', fontFamily: 'var(--font-sans)' }}>{item.label}</div><div style={{ fontSize: 10, color: '#8E8E8E' }}>{item.sub}</div></div>
              <span style={{ marginLeft: 'auto', color: '#C7C7C7', fontSize: 14 }}>›</span>
            </div>
          ))}
          {/* Recent leads grid */}
          {leads.length > 0 && <>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#262626', padding: '16px 0 8px', fontFamily: 'var(--font-sans)' }}>Recent Leads</div>
            <div className="ig-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 2 }}>
              {leads.slice(0, 9).map(l => {
                const domain = (l.website || '').replace(/https?:\/\//, '').replace(/\/.*/, '');
                return (
                  <div key={l.lead_id} onClick={() => navigate(`/bizdev/leads/${l.lead_id}`)}
                    style={{ aspectRatio: '1', background: '#EFEFEF', borderRadius: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                    {domain && <img src={`https://www.google.com/s2/favicons?domain=${domain}&sz=128`} alt=""
                      style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'contain', marginBottom: 4 }}
                      onError={(e) => e.target.style.display = 'none'} />}
                    <div style={{ fontSize: 10, fontWeight: 600, color: '#262626' }}>{l.company_name}</div>
                    {l.ai_score && <div style={{ fontSize: 9, color: '#8E8E8E' }}>★{l.ai_score}</div>}
                  </div>
                );
              })}
            </div>
          </>}
        </div>
      )}

      {/* All view — with query (search all categories) */}
      {view === "all" && query && (
        <div style={{ padding: '0 16px' }}>
          {filtered(leads, ["company_name", "industry"]).slice(0, 5).map(l => (
            <div key={l.lead_id} onClick={() => navigate(`/bizdev/leads/${l.lead_id}`)}
              style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderBottom: '1px solid #EFEFEF', cursor: 'pointer' }}>
              <img src={`https://www.google.com/s2/favicons?domain=${(l.website || '').replace(/https?:\/\//, '').replace(/\/.*/, '')}&sz=128`} alt=""
                style={{ width: 32, height: 32, borderRadius: 8, objectFit: 'contain', background: '#EFEFEF' }} onError={(e) => e.target.style.display = 'none'} />
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#262626' }}>{l.company_name}</div>
                <div style={{ fontSize: 10, color: '#8E8E8E' }}>Lead · {l.industry || ''}</div>
              </div>
            </div>
          ))}
          {filtered(accounts, ["company_name"]).slice(0, 5).map(a => (
            <div key={a.lead_id} onClick={() => navigate(`/bizdev/accounts/${a.lead_id}`)}
              style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderBottom: '1px solid #EFEFEF', cursor: 'pointer' }}>
              <img src={`https://www.google.com/s2/favicons?domain=${(a.website || '').replace(/https?:\/\//, '').replace(/\/.*/, '')}&sz=128`} alt=""
                style={{ width: 32, height: 32, borderRadius: 8, objectFit: 'contain', background: '#EFEFEF' }} onError={(e) => e.target.style.display = 'none'} />
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#262626' }}>{a.company_name}</div>
                <div style={{ fontSize: 10, color: '#8E8E8E' }}>Client{a.is_retainer ? ' · Retainer' : ''}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
